import styled from '../../../../../../../styled';

export const LeftBorderedContent = styled.div`
  border-left: 1px solid var(--ds-color-border-subtle);
  display: flex;
  flex-direction: column;
  padding-left: var(--ds-size-4);
  gap: var(--ds-size-2);
`;

export const LeftPaddedContent = styled.div`
  padding-left: var(--ds-size-8);
`;

export const CheckedContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-4);
`;
